import 'arrayq';
import elementClass from 'element-class';

import { customStylesheet } from '../customStylesheet';
import { NodeTextPosition, parents } from '../domop';
import { classWhitelist, rxClassWhitelist } from './settings';

import cx from './style.less';

function selectionCss(classes: string[]) {
    const styles = classes.qSelect((name) => `.${cx('selection-scope')} .${name}, .${cx('selection-scope')} .${name} * { cursor: text!important; }`);
    const reg = customStylesheet(styles.join(''));
    return reg;
}

export function enterSelectionScope() {
    const interactionEvents = ['click', 'mousedown', 'mouseup', 'mousemove', 'touchstart', 'touchend', 'keypress', 'keydown', 'keyup'];
    const preventDefaultInSelectable = (e: Event) => {
        const isSelectable = parents(e.target as Node, document.body).qAny((el) => rxClassWhitelist.test((el as Element).className));
        if (isSelectable) {
            e.preventDefault();
        }
    };

    // Enter selection mode in document.
    const css = selectionCss(classWhitelist);
    elementClass(document.body).add(cx('selection-scope'));
    interactionEvents.forEach((name) => document.body.addEventListener(name, preventDefaultInSelectable, true));

    if (!NodeTextPosition.fromPoint(0, 0)) {
        elementClass(document.body).add(cx('selection-scope--compat'));
    }

    return () => {
        // Exit selection mode from document.
        css.remove();
        elementClass(document.body).remove(cx('selection-scope'));
        interactionEvents.forEach((name) => document.body.removeEventListener(name, preventDefaultInSelectable, true));
    };
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/highlight/interaction.tsx